import { SanitizedOrder } from '../../../../../../types/order/Order';
import useInvoices from '../../../hooks/invoices/useInvoices';
import { formatDateEnriched } from '../../../../../../helpers/dateEnriched';

const ReasonsDisabled = {
  FAILED_FETCH: 'Could not fetch the invoices',
  NO_INVOICES: 'There are no invoices available',
};

const useDownloadInvoice = (order: SanitizedOrder) => {
  const { invoices, status } = useInvoices({
    dates: { fromDate: formatDateEnriched(new Date(order.createdAt)), toDate: formatDateEnriched(new Date()) },
    orderNumber: order.orderNumber,
  });

  if (status === 'error') {
    return {
      enabled: false,
      reasonDisabled: ReasonsDisabled.FAILED_FETCH,
      invoices: [],
    };
  }

  if (typeof invoices === 'undefined' || invoices.length === 0) {
    return {
      enabled: false,
      reasonDisabled: ReasonsDisabled.NO_INVOICES,
      invoices: [],
    };
  }

  return {
    enabled: true,
    invoices,
  };
};

export default useDownloadInvoice;
